import { createFileRoute } from "@tanstack/react-router";

import SectionsPage from "@/app/design-system/sections/SectionsPage";

export const Route = createFileRoute("/admin/design-system/sections")({
  component: SectionsPage,
});
